/**
 * Map backend Color_Coding values (De Novo and similar) onto Alert severity.
 * Unrecognized / empty values return "warning".
 */
export function mapColorCodingToSeverity(colorCoding) {
  const level = (colorCoding || "").toLowerCase();

  if (level === "green") return "success";
  if (level === "red") return "error";
  if (level === "yellow" || level === "orange" || level === "amber") {
    return "warning";
  }
  return "warning";
}

/**
 * Map KPI / leadership AlertLevel onto Alert severity.
 * Unrecognized / empty values return "warning".
 */
export function mapAlertToSeverity(alert) {
  const level = (alert?.AlertLevel || alert?.alertLevel || "").toLowerCase();

  if (level === "green") return "success";
  if (level === "red") return "error";
  return "warning";
}
